var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInstallDesktopChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 20h14v2c0 1.105-0.784 2-1.75 2h-10.5c-0.966 0-1.75-0.895-1.75-2v-2Z",
    fill: "#626365"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 1c.63 0 1.141 .47 1.141 1.05v10.367l3.411-3.139c.446-0.41 1.168-0.41 1.614 0c.445 .41 .445 1.075 0 1.484l-5.359 4.931c-0.446 .409-1.168 .409-1.614 0l-5.359-4.931c-0.445-0.409-0.445-1.074 0-1.484c.446-0.41 1.168-0.41 1.614 0l3.411 3.139v-10.367c0-0.58 .511-1.05 1.141-1.05Z",
    fill: "#626365"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.366 2h-5.96c-1.881 0-3.406 1.547-3.406 3.455v12.09c0 1.908 1.525 3.455 3.406 3.455h17.188c1.881 0 3.406-1.547 3.406-3.455v-1.727h-2.044v1.727c0 .764-0.609 1.382-1.362 1.382h-17.188c-0.753 0-1.363-0.618-1.363-1.382v-12.09c0-0.764 .61-1.382 1.363-1.382h5.96v-2.073Z",
    fill: "#626365"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstallDesktopChrome);
export default __webpack_public_path__ + "static/media/ic-Install-desktop-chrome.077ba1f9491cd74b0ffe006c4e27470d.svg";
export { ForwardRef as ReactComponent };